import React, {Component} from 'react';
import Link from 'gatsby-link';
import { Container, Accordion, Icon } from 'semantic-ui-react';

import './faq-page.scss'

export default class AccordionExampleStyled extends Component {
  state = { activeIndex: 0 }


  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index

    this.setState({ activeIndex: newIndex })
  }

  render() {
    const { activeIndex } = this.state

    return (

      <div>
        {/* Hero */}

        <div className="faq-page">
        <Container>

          <h1 className="faq-page__headline">FAQ</h1>

          <Accordion fluid styled>
        <Accordion.Title active={activeIndex === 0} index={0} onClick={this.handleClick}>
          <Icon name='dropdown' />
          Conference Program
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 0}>
          <p>
            The conference program will be available by October 2018.
          </p>
        </Accordion.Content>

        <Accordion.Title active={activeIndex === 1} index={1} onClick={this.handleClick}>
          <Icon name='dropdown' />
          Conference Sessions
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 1}>
          <p><strong>I will need speakers for my presentation. How do I order these?</strong></p>
           <p>
             We cannot provide speakers for individual conference sessions, so you should plan to bring your own. We will have A/V assistance on site to help you troubleshoot any issues with projecting sound. There will be an LCD projector in each session room.
          </p>
        </Accordion.Content>

        <Accordion.Title active={activeIndex === 2} index={2} onClick={this.handleClick}>
          <Icon name='dropdown' />
          Final Submissions
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 2}>
          <p><strong>Why does my submission type say “Poster” or “Brief Research Report” if I submitted my proposal as a Full Research Report?</strong></p>
          <p>
           All Academic does not differentiate between submission type and accepted type. If your proposal was accepted in an alternate format, your submission type will be the alternate format. You should prepare your final paper according to the guidelines for the submission type that is reported in the system currently, not the submission type you indicated when submitting the proposal.
          </p>
        </Accordion.Content>
        <Accordion.Title active={activeIndex === 3} index={3} onClick={this.handleClick}>
          <Icon name='dropdown' />
          Printing Posters
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 3}>
          The maximum poster size is 48 inches wide and 36 inches high. Printing fabric posters has become popular over the last few years (and they pack nicely in a suitcase). <a href="https://support.spoonflower.com/hc/en-us/articles/204266984-How-to-Create-a-Fabric-Presentation-Poster-from-a-PowerPoint-or-PDF" target="_blank">Here</a> is one tutorial for doing this relatively cheaply. Other poster printing sites also offer this option for additional costs.
        </Accordion.Content>
        <Accordion.Title active={activeIndex === 4} index={4} onClick={this.handleClick}>
          <Icon name='dropdown' />
          Registration
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 4}>
        <p><strong>When can I register for the conference?</strong></p>
        <ul>
          <li>Conference registration will open on May 11, 2018. </li>
          <li>Speaker registration must be completed by September 10, 2018. </li>
          <li>Early registration will end October 16, 2018. </li>
          <li>Online registration will end November 1, 2018. </li>
        </ul>

        <p><strong>Which meals are included in the cost of registration for the conference?</strong></p>
        <p>For Faculty, Student and Guest registrations, meals that are included as part of your registration fee include:</p>
        <ul>
          <li>-Thursday night reception </li>
          <li>-Friday and Saturday lunches </li>
          <li>-Saturday dinner/entertainment </li>
        </ul>

        <p>Friday dinner and all breakfasts are on your own.  Coffee will be available before sessions and during the breaks.</p>

        </Accordion.Content>

        <Accordion.Title active={activeIndex === 5} index={5} onClick={this.handleClick}>
          <Icon name='dropdown' />
          Visas (Information for those traveling from outside of the U.S.A.)
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 5}>
        <p>If you are coming from outside the U.S., remember to get a visa, if necessary! To allow enough time for your visa request to be processed by your country of origin, we recommend you check the <a href="https://travel.state.gov/content/visas/en.html" target="_blank">U.S. Government’s web site</a> regarding visas.</p>
        <p>If you are concerned about obtaining visa status for entry to the U.S. before registering, please contact Andy Tyminski, <a href="mailto:amt23@clemson.edu">amt23@clemson.edu</a>.</p>
        </Accordion.Content>

        <Accordion.Title active={activeIndex === 6} index={6} onClick={this.handleClick}>
          <Icon name='dropdown' />
         Transportation
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 6}>
        <p><strong>I am not staying at or near the Hyatt Regency. Is there a shuttle that can drive me to the hotel for the conference?</strong></p>
        <p>No, however, the other downtown hotels are easily within walking distance from the Hyatt.  There are also cabs and Uber available in Greenville.</p>

        <p><strong>How should I get to the Hyatt Regency from the Airport?</strong></p>
        <p>Please see our Travel tab on this site for links to these services.</p>
        </Accordion.Content>
        <Accordion.Title active={activeIndex === 7} index={7} onClick={this.handleClick}>
          <Icon name='dropdown' />
         Room Sharing
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 7}>
                <p><strong>How can I connect with other conference attendees who are interested in sharing a room?</strong></p>
                <p>Feel free to use this <a target="_blank" href="https://docs.google.com/document/d/1X7pyDHuEKPoBf9O_xmpASVan17YKMhYjkDrW0Ig1pBw/edit?usp=sharing">Google doc</a> to assist with coordinating these arrangements.</p>
        </Accordion.Content>

      </Accordion>
        </Container>

        </div>


        {/* Footer */}
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/pages/faq/index.js